/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  DeleteOperationChainItemMutationRequest,
  DeleteOperationChainItemMutationResponse,
} from "../types/DeleteOperationChainItem.ts"

export const deleteOperationChainItemMutationKey = () =>
  [{ url: "/v1/operation-chain/delete-operation-chain-item" }] as const

export type DeleteOperationChainItemMutationKey = ReturnType<
  typeof deleteOperationChainItemMutationKey
>

/**
 * @summary Delete an operation chain item
 * {@link /v1/operation-chain/delete-operation-chain-item}
 */
export async function deleteOperationChainItem(
  data: DeleteOperationChainItemMutationRequest,
  config: Partial<RequestConfig<DeleteOperationChainItemMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    DeleteOperationChainItemMutationResponse,
    ResponseErrorConfig<Error>,
    DeleteOperationChainItemMutationRequest
  >({
    method: "POST",
    url: `/v1/operation-chain/delete-operation-chain-item`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function deleteOperationChainItemMutationOptions(
  config: Partial<RequestConfig<DeleteOperationChainItemMutationRequest>> & {
    client?: typeof fetch
  } = {}
) {
  const mutationKey = deleteOperationChainItemMutationKey()
  return mutationOptions<
    ResponseConfig<DeleteOperationChainItemMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteOperationChainItemMutationRequest },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return deleteOperationChainItem(data, config)
    },
  })
}

/**
 * @summary Delete an operation chain item
 * {@link /v1/operation-chain/delete-operation-chain-item}
 */
export function useDeleteOperationChainItem<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteOperationChainItemMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: DeleteOperationChainItemMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<DeleteOperationChainItemMutationRequest>> & {
      client?: typeof fetch
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? deleteOperationChainItemMutationKey()

  const baseOptions = deleteOperationChainItemMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<DeleteOperationChainItemMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteOperationChainItemMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<DeleteOperationChainItemMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteOperationChainItemMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<DeleteOperationChainItemMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: DeleteOperationChainItemMutationRequest },
    TContext
  >
}
